import React from 'react';
import { Outlet } from 'react-router-dom';
import { Box } from '@mui/material';
import UserCard from '../Components/UserCard/UserCard';

export default function ProfilePage() {
    return (
        <Box
            sx={{
                height: '100%',
                width: '98vw',
                display: 'flex',
                justifyContent: 'center'
            }}
        >
            <Box
                sx={{ display: 'flex', width: '100%', maxWidth: '1230px' }}
            >
                <Box sx={{ width: '300px', height: '100%' }}>
                    <UserCard />
                </Box>

                <Box
                    sx={{
                        flexGrow: 1,          // expand to fill available space
                        flexShrink: 1,        // shrink if viewport is too small
                        maxWidth: '950px',    // never exceed 950px
                        height: '100%'
                    }}
                >
                    <Outlet />
                </Box>
            </Box>
        </Box>
    );
}
